import React from "react";
import { AdBannerData } from "../data/adBannerData";

// AdBannerData 인터페이스를 사용해 타입 정의
const SajuContentSlider = ({
  headerText,
  highlightText,
  detailText,
  detailTextColor,
  price,
  bgColor,
  borderGradient,
  priceBg,
  priceTextColor,
  link,
}: AdBannerData) => {
  // CSS 변수를 사용하여 동적 스타일 적용
  const style = {
    "--bg-color": bgColor,
    "--border-gradient": borderGradient,
    "--detail-text-color": detailTextColor,
    "--price-bg": priceBg,
    "--price-text-color": priceTextColor,
  } as React.CSSProperties;

  return (
    <div
      className="slide"
      style={style}
      onClick={() => {
        window.open(link, "_blank");
      }}
    >
      <div className="slide_content_wrapper">
        <div className="slide-header">
          <h3>{headerText}</h3>
          {highlightText && <h3 className="highlight">{highlightText}</h3>}
        </div>
        <div className="slide-details">
          <h3 className="detail-text">{detailText}</h3>
          <div className="price-tag">
            <h3>{price}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SajuContentSlider;
